<template>
  <v-container class="dashboard-widget-fluid">
    <slot name="title">
      <h5><b>{{ title }}</b></h5>
    </slot>
    <slot name="content">
      {{ content }}
    </slot>
  </v-container>
</template>

<script>
export default {
  name: 'Widget',
  props: ['title', 'content']
}
</script>

<style scoped>
  .dashboard-widget-fluid {
    border: 1px solid black;
    border-radius: 5px;
    overflow: auto;
    padding: 1em;
    width: 100%;
    height: 100%;
    margin: 0;
  }

  .centered {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .large {
    font-size: 770%;
  }
  .count {
    font-weight: bold;
  }
</style>
